import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {BottomNavigationBarMenuItemTextDefaultBox} from "./bottom-navigation-bar-menu-item-text.default.box";
import {BottomNavigationBarMenuItemTextCasino777Box} from "./bottom-navigation-bar-menu-item-text.casino777.box";


export const BottomNavigationBarMenuItemTextBox = styledByTheme(BottomNavigationBarMenuItemTextDefaultBox)
  .forCasino777(BottomNavigationBarMenuItemTextCasino777Box)
  .apply();
